import React, {useRef, useState, useEffect } from 'react'



function AnimationContainer() {
  //These are used in setting the size the 3D N
  var rows = [], i = 0, len = 20
  while (++i <= len) rows.push(i)
  let nWidth = 80
  let[scaledMouseDegreeX, setScaledMouseDegreeX] = useState(45)
  if (window.innerWidth > 768){
      nWidth = 100
  }
  const[cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 })
  const[frontGradientX, setFrontGradientX] = useState(50)
  const[frontGradientY, setFrontGradientY] = useState(50)
  const[topGradientX, setTopGradientX] = useState(100) //Left start point is 0
  const[topGradientY, setTopGradientY] = useState(0) //Left start pont is 100

  const [threeDNPosition, setThreeDNPosition] = useState({ x: 0, y: 0 })

 useEffect(() => {
    const N = document.querySelector('.homeBlock__svgContainer')
    const NNN = document.querySelector('.cube')

    const updateNPosition = () => {
    if (!NNN) return
      const threeDN = NNN.getBoundingClientRect()
      setThreeDNPosition({ x: threeDN.left + (threeDN.width / 2), y: threeDN.top + (threeDN.height / 2)})
    }
    if (NNN) updateNPosition()

    window.addEventListener('scroll', () => {
      if (NNN) updateNPosition()
    })
    
    window.addEventListener("resize", ()=>{
      if (NNN) updateNPosition()
    })

    return () => {
      window.removeEventListener('scroll', () => {
        if (NNN) updateNPosition()
      })
      window.removeEventListener("resize", ()=>{
        if (NNN) updateNPosition()
      })
    }
  }, [])

  useEffect(()=>{
    //This is for the 3D N animated gradient
    const handleMouseMove = (event) => {
        const { clientX, clientY } = event
        setCursorPosition({ x: clientX, y: clientY })
        setScaledMouseDegreeX((clientX / window.innerWidth) * 30 + 30) //This is just for the rotation animation

        const xMiddle = window.innerWidth / 2
        const yMiddle = window.innerHeight / 2
        let frontXOffset = threeDNPosition.x - xMiddle
        let frontYOffset = threeDNPosition.y - yMiddle

        //This is the gradient of the 2 bottom Ns
        setFrontGradientX(((clientX / window.innerWidth) * 200) - 100)
        setFrontGradientY(((((clientY + frontYOffset)/ (window.innerHeight + frontYOffset)) * 200)) - 100)

        //This is the converted  gradient of the top N
        setTopGradientX(((((clientX)/ (window.innerWidth)) * 100)) + (((clientY)/ (window.innerHeight)) * 100))
        setTopGradientY((100 - ((clientX / window.innerWidth) * 100)) + (((clientY)/ (window.innerHeight)) * 100))


        const path = document.querySelector("#technologyBlock__sqlSvgPath1")
    }

    document.addEventListener('mousemove', handleMouseMove)

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
    }
  },[threeDNPosition])

  return (
      <div className="animationContainer">
      {/* <Floating scaledMouseDegreeX={scaledMouseDegreeX} threeDNPosition={threeDNPosition}/> */}
        <div className="sceneBody">
          <div className="scene">
            <div className="cube" style={{ transform: `rotateY(${scaledMouseDegreeX}deg)` }}>
              {

                rows.map(function (i) {
                  return(
                    <div className="front" style={{ transform: `translateZ(${nWidth + i}px)` }}>

                      <svg id="Layer_1" fill='url(#frontGrad)' xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="-255 347 100 100">
                        <defs>
                          <radialGradient id="frontGrad" cx={`${frontGradientX}%`} cy ={`${frontGradientY}%`} r="70%" fx={`${frontGradientX}%`} fy={`${frontGradientY}%`}>
                            <stop offset="0%" stop-color="rgb(255, 255, 255)" stop-opacity="0.9"></stop>
                            <stop offset="100%" stop-color="rgb(150, 150, 150)" stop-opacity="0.9"></stop>
                          </radialGradient>
                        </defs>
                        <path class="st0" d="M-155,347h-28.4c-1.4,0,1.6,0,0,0l0,61.8L-227,348c-0.5-0.6,0,0-0.8-1l-27.2,0c0,1.2,0-1.2,0,0v100 c0,1.2,0-1.7,0,0h28.4c1.4,0-1.4,0,0,0l0-61.8L-183,446c0.5,0.6,0,0,0.8,1h27.2c0-1.5,0,1.2,0,0V347C-155,345.8-155,348.1-155,347z"/>
                      </svg>
                    </div>
                  );
                })
              }
              {/* <div className="back"></div> */}
              {
                rows.map(function (i) {
                  return(
                    <div className="left" style={{ transform: `rotateY(270deg) translateZ(${nWidth + i}px)` }}>
                      <svg id="Layer_1" fill='url(#leftGrad)' xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="-255 347 100 100">
                        <defs>
                          <radialGradient id="leftGrad" cx={`${frontGradientX + 100}%`} cy ={`${frontGradientY}%`} r="70%" fx={`${frontGradientX + 100}%`} fy={`${frontGradientY}%`}>
                            <stop offset="0%" stop-color="rgb(255, 255, 255)" stop-opacity="0.9"></stop>
                            <stop offset="100%" stop-color="rgb(150, 150, 150)" stop-opacity="0.9"></stop>
                          </radialGradient>
                        </defs>
                        <path class="st0" d="M-155,347h-28.4c-1.4,0,1.6,0,0,0l0,61.8L-227,348c-0.5-0.6,0,0-0.8-1l-27.2,0c0,1.2,0-1.2,0,0v100 c0,1.2,0-1.7,0,0h28.4c1.4,0-1.4,0,0,0l0-61.8L-183,446c0.5,0.6,0,0,0.8,1h27.2c0-1.5,0,1.2,0,0V347C-155,345.8-155,348.1-155,347z"/>
                      </svg>
                    </div>
                  );
                })
              }
              {/* <div className="right"></div> */}
              {
                rows.map(function (i) {
                  return(
                    <div className="top" style={{ transform: `translateY(-${nWidth + i}px) rotateX(90deg) rotateZ(90deg)` }}>
                      <svg id="Layer_1" fill='url(#topGrad)' xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="-255 347 100 100">
                        <defs>
                          <radialGradient id="topGrad" cx={`${topGradientX}%`} cy ={`${topGradientY}%`} r="70%" fx={`${topGradientX}%`} fy={`${topGradientY}%`}>
                            <stop offset="0%" stop-color="rgb(255, 255, 255)" stop-opacity="0.9"></stop>
                            <stop offset="100%" stop-color="rgb(150, 150, 150)" stop-opacity="0.9"></stop>
                          </radialGradient>
                        </defs>
                        <path class="st0" d="M-155,347h-28.4c-1.4,0,1.6,0,0,0l0,61.8L-227,348c-0.5-0.6,0,0-0.8-1l-27.2,0c0,1.2,0-1.2,0,0v100 c0,1.2,0-1.7,0,0h28.4c1.4,0-1.4,0,0,0l0-61.8L-183,446c0.5,0.6,0,0,0.8,1h27.2c0-1.5,0,1.2,0,0V347C-155,345.8-155,348.1-155,347z"/>
                      </svg>
                    </div>
                  );
                })
              }
              {/* <div className="bottom"></div> */}
            </div>
          </div>
        </div>
      </div>
  )
}

export default AnimationContainer